<template>
  <div>
    <el-dialog title="纠错下单可亏损配置" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false">
      <div style="padding: 10px; background-color: #ddebff; color: #333;font-size: 13px;line-height: 20px;">
        <div>客服在 下单纠错 操作时，若计算出 守兔的结算价-用户支付价 > 下方配置的金额。则显示亏损过大无法下单，引导客服操作关单，关单后自动告知用户出票失败。</div>
      </div>
<!--      <div style="display: flex;margin-top: 10px;">-->
<!--        <div class="container-top-l">已经选中主体数量：</div>-->
<!--        <span>{{id.length}} 个</span>-->
<!--      </div>-->
      <div class="container">
        <div class="lable">可亏损金额：</div>
        <el-form :model="form" :rules="rules" ref="form" label-width="140px" label-position="left" style="margin-top: 20px;">
          <el-form-item prop="configValue0">
            <template #label>
              <el-radio v-model="configType" :label="0">固定金额</el-radio>
            </template>
            <el-input v-model="form.configValue0" placeholder="请输入">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item prop="configValue1">
            <template #label>
              <div style="position: relative;">
                <el-radio v-model="configType" :label="1">市场价比例</el-radio>
                <span style="position: absolute;right: 12px;top: 0;">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="以守兔数据源的市场价进行计算"
                    placement="bottom"
                  >
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </span>
              </div>
            </template>
            <el-input v-model="form.configValue1" placeholder="请输入">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </el-form>
      </div>

      <div class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button :loading="loading" type="primary" @click="submitForm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {matchNegativePart1} from '@/utils/regExp'
import mini from "@/api/mini";
const MiniModel = new mini()

export default {
  data() {
    return {
      dialogVisible: false,
      submiVisible: false,
      loading: false,
      row: {},
      form: {
        configValue0: "",
        configValue1: "",
      },
      rules: {
        configValue0: [
          { required: false, message: "请输入数字，可保留一位小数", trigger: ["blur", "change"],pattern: matchNegativePart1, },
        ],
        configValue1: [
          { required: false, message: "请输入数字，可保留一位小数", trigger: ["blur", "change"],pattern: matchNegativePart1, },
        ],
      },
      loadingSelect: false,
      id:[],
      configType: 0,
    };
  },
  watch: {
    configType(val) {
      if(val === 0) {
        this.form.configValue1 = ''
      }else if(val === 1) {
        this.form.configValue0 = ''
      }
    },
  },
  methods: {
    init(type,row) {
      console.log(type,row,'type,row========')
      this.id = []
      this.form = {
        configValue0: "",
        configValue1: "",
      }
      // 多选
      if(type === 1) {
        this.row = {}
        this.id = row
      }else if(type === 2) {
        this.row = row
        this.id = [row.id]
        this.configType = row.config_type ? 1 : 0
        console.log(row.fix_price,'this.configType',row.rate_price,row.config_type)
        if(row.config_type === 0) {
          this.form.configValue0 = row.fix_price
        }else if(row.config_type === 1) {
          this.form.configValue1 = row.rate_price
        }
      }
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });

    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if(this.configType === 0 && this.form.configValue0 === '' || this.configType === 1 && this.form.configValue1 === '') {
            this.$message.error('请输入亏损金额');
            return
          }
          this.loading = true;
          if(this.id.length === 0) {
            this.$message.error('请选择需要调价的主体');
            return
          }
          MiniModel.updateOcrLose({
            id: this.id.join(','),
            configType: this.configType,
            configValue: this.configType === 0 ? this.form.configValue0 : this.form.configValue1,
          }).then(res => {
            console.log(res,'sssssss1')
            if (res.data.code === 200) {
              this.$message.success(res.data.message);
              this.dialogVisible = false;
              this.submiVisible = false;
              this.$emit('refresh');
            } else {
              this.$message.error(res.data.message);
            }
          }).catch(err => {
            this.$message.error(err.message);
          })
            .finally(() => {
              this.loading = false;
            });
        } else {
          // this.$message.error("请检查输入的值是否正确");
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.form.resetFields(); // 清空表单内容和校验状态
    },
  },
};
</script>

<style scoped lang="less">
.dialog-footer {
  text-align: right; /* 将按钮对齐到右侧 */
  padding-right: 10px; /* 根据需要调整右侧边距 */
}
.stron{
  color: #1890ff;
  text-decoration: underline;
  cursor: pointer;
}
.container{
  display: flex;
  .lable{
    margin-top: 30px;
    margin-right: 10px;
    color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/promotion/manage/modal/fuzzySet.vue